import { type FC } from 'react';
import { VyIcon } from '@vy/ui-design-system';
import { Typography, styled } from '@mui/material';
import { ControlledTextInput } from '../../../components/ControlledTextInput';
import type { MorningRegisterFormControl } from '../MorningRegisterFormSchema';
import { CREDENTIALS_LINK } from './register-to-morning-components-consts';

interface Props {
  control: MorningRegisterFormControl;
}

export const MorningRegistration: FC<Props> = ({ control }) => {
  const handleCredentialsLinkClick = () => window.open(CREDENTIALS_LINK);

  return (
    <FormContainer>
      <LogoContainer>
        <VyIcon
          icon="MorningIcon"
          style={{
            transform: 'scale(0.38)',
            transformOrigin: 'top left',
          }}
        />
      </LogoContainer>
      <Typography variant="h4">Enter your Morning Credentials to get started</Typography>
      <ControlledTextInput
        name="apiKey"
        control={control}
        label="API Key"
        placeholder="Enter API Key here..."
        defaultValue=""
      />
      <ControlledTextInput
        name="secretId"
        control={control}
        label="Secret ID"
        placeholder="Enter Secret ID here..."
        defaultValue=""
      />
      <Typography
        variant="subtitle2"
        sx={{ color: '#3A78F8', cursor: 'pointer' }}
        onClick={handleCredentialsLinkClick}
      >
        Where can I find my credentials?
      </Typography>
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

const LogoContainer = styled('div')({
  width: 132,
  height: 132,
});
